import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';
import { sizes } from '../../theme/tokens';

// Geometry derived from tokens to match Figma exactly:
//   outer ring outer-edge diameter = h18 (18px)
//   inner dot diameter             = h12 (12px)
// All values are unitless SVG coordinates — no raw px strings.
const C = sizes.height.h18 / 2; // centre = 9
const outerR = C - sizes.border.bd1 / 2; // 8.5 → outer edge at 9 = h18/2
const dotR = sizes.height.h12 / 2; // 6   → dot diameter = h12

const VIEWBOX = `0 0 ${sizes.height.h18} ${sizes.height.h18}`;

/**
 * Unchecked radio icon — outer ring only.
 * Outer edge diameter = h18 (18px), stroke = bd1 (1px).
 * Replaces MUI's RadioButtonUncheckedIcon; used as Radio defaultProps.icon.
 */
export function RadioUncheckedIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox={VIEWBOX}>
      <circle cx={C} cy={C} r={outerR} stroke="currentColor" strokeWidth={sizes.border.bd1} fill="none" />
    </SvgIcon>
  );
}

/**
 * Checked radio icon — outer ring (h18) + inner filled dot (h12).
 * Replaces MUI's RadioButtonCheckedIcon; used as Radio defaultProps.checkedIcon.
 */
export function RadioCheckedIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox={VIEWBOX}>
      <circle cx={C} cy={C} r={outerR} stroke="currentColor" strokeWidth={sizes.border.bd1} fill="none" />
      <circle cx={C} cy={C} r={dotR} fill="currentColor" />
    </SvgIcon>
  );
}
